import { render, staticRenderFns } from "./OtherDocumentManager.vue?vue&type=template&id=3c671512&"
import script from "./OtherDocumentManager.vue?vue&type=script&lang=js&"
export * from "./OtherDocumentManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports